/**
 * Single source of truth for which ingest subfolder a file extension belongs
 * in, mirroring the server's IngestFileTypeMap (server/webApi/DataTransformerAPI
 * /Models/IngestFileType.cs). The server is always the one that actually
 * resolves an upload's destination folder - this mirror exists only for the
 * file-picker accept filter, client-side fast-fail validation, and the
 * file-type label/icon shown in the upload list and tree.
 */
export enum IngestFileType {
  Csv = 'Csv',
  Excel = 'Excel',
  Feather = 'Feather',
  Parquet = 'Parquet',
  Text = 'Text'
}

export interface IngestFileTypeEntry {
  extension: string;
  type: IngestFileType;
  folderName: string;
}

export const INGEST_FILE_TYPES: IngestFileTypeEntry[] = [
  { extension: '.csv', type: IngestFileType.Csv, folderName: 'CSV' },
  { extension: '.xlsx', type: IngestFileType.Excel, folderName: 'Excel' },
  { extension: '.ftr', type: IngestFileType.Feather, folderName: 'Feather' },
  { extension: '.parquet', type: IngestFileType.Parquet, folderName: 'Parquet' },
  { extension: '.txt', type: IngestFileType.Text, folderName: 'Text' },
];

export const INGEST_FILE_ACCEPT = INGEST_FILE_TYPES.map(t => t.extension).join(',');

export function getIngestFileTypeForName(fileName: string): IngestFileTypeEntry | undefined {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex < 0) { return undefined; }
  const extension = fileName.substring(dotIndex).toLowerCase();
  return INGEST_FILE_TYPES.find(t => t.extension === extension);
}
